// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SearchProducts = registerClientReference(
    function() { throw new Error("Attempted to call SearchProducts() from the server but SearchProducts is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/header/search-products/index.tsx",
    "SearchProducts",
);
export const getProductImage = registerClientReference(
    function() { throw new Error("Attempted to call getProductImage() from the server but getProductImage is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/header/search-products/index.tsx",
    "getProductImage",
);
export const getStoreName = registerClientReference(
    function() { throw new Error("Attempted to call getStoreName() from the server but getStoreName is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/header/search-products/index.tsx",
    "getStoreName",
);
export const renderProductPrice = registerClientReference(
    function() { throw new Error("Attempted to call renderProductPrice() from the server but renderProductPrice is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/shared/header/search-products/index.tsx",
    "renderProductPrice",
);
